import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

import Bräuer from './views/people/Bräuer.vue';
import Flo from './views/people/Flo.vue';
import Jan from './views/people/Jan.vue';
import Lef from './views/people/Lef.vue';
import Dominik from './views/people/Dominik.vue';
import Bruno from './views/people/Bruno.vue';
import Tim from './views/people/tim/index.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/Br%C3%A4uer',
			name: 'braeuer',
			component: Bräuer
		},
		{
			path: '/Flo',
			name: 'flo',
			component: Flo
		},
		{
			path: '/Jan',
			name: 'jan',
			component: Jan
		},
		{
			path: '/Lef',
			name: 'lef',
			component: Lef
		},
		{
			path: '/Dominik',
			name: 'dominik',
			component: Dominik
		},
		{
			path: '/Bruno',
			name: 'bruno',
			component: Bruno
		},
		{
			path: '/Tim',
			name: 'tim',
			component: Tim
		}
	]
});
